import { type Feature, featureCollection, type LineString, lineString } from '@turf/helpers';
import type { LngLat } from '../types/Geo';
import { decodeSegmentLngLat } from './legacyGeoJSONConversions';

/**
 * Decodes an array of Google-encoded polyline strings into a GeoJSON
 * FeatureCollection of LineStrings, suitable for a Mapbox geojson source.
 *
 * Polylines with fewer than two decoded points are dropped — Mapbox can't
 * render a one-point LineString and we'd rather not feed it invalid features.
 */
export default function polylinesToFeatureCollection(encodedPolylines: string[]) {
  const features: Feature<LineString>[] = [];

  for (const encoded of encodedPolylines) {
    const coordinates = decodeSegmentLngLat({ polyline: { pointsData: encoded } }) as LngLat[];
    if (coordinates.length > 1) {
      features.push(lineString(coordinates));
    }
  }

  return featureCollection<LineString>(features);
}
